// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.post-comments {
    border-top: thin solid var(--main-border-color);
    padding: 10px;
}
.post-comments .show-comments {
    text-align: center;
}
.post-comments .show-comments a:link,
.post-comments .show-comments a:visited,
.post-comments .show-comments a:active {
    display: block;
    border-radius: 10px;
    padding: 5px;
}

.post-comments .show-comments a:hover {
    background-color: white;
}

`, "",{"version":3,"sources":["webpack://./client/components/posts/Post/PostComments/PostComments.css"],"names":[],"mappings":"AAAA;IACI,+CAA+C;IAC/C,aAAa;AACjB;AACA;IACI,kBAAkB;AACtB;AACA;;;IAGI,cAAc;IACd,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B","sourcesContent":[".post-comments {\n    border-top: thin solid var(--main-border-color);\n    padding: 10px;\n}\n.post-comments .show-comments {\n    text-align: center;\n}\n.post-comments .show-comments a:link,\n.post-comments .show-comments a:visited,\n.post-comments .show-comments a:active {\n    display: block;\n    border-radius: 10px;\n    padding: 5px;\n}\n\n.post-comments .show-comments a:hover {\n    background-color: white;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
